G.featureUnlock = { // The rest of the settings are at other-match3-engine\js\Config\featureUnlockDefault.js
  useNoGates: true,
  extraCoinsPerMove: {
    enabled: true,
  },
  useWebGLRenderer: true,
  achievementGifts: false,
  freeFailFlowWheelSpin: false,
  multipleExtraMovesFailFlow: true,
  requestMoveHelp: true,
  tournamentPromo: true, // Whether to show the tournament promotion window / button
  friendshipChest: { // Friendship chest
    enabled: true,
    storyMode: true, // Have normal friendship chest or story mode
  },
  gameTriggeredMessages: { // Activates game-triggered bot messages
    botMessages: true,
  },
  treasureHunt: { // Treasure Hunt super, now active on certain days!
    enabled: true,
  },
  transactionTracking: {
    track: { // Activates "high-value" transaction event tracking
      ss: true, // player inventory snapshots
      rm: true, // real-money transactions
      inv: true, // in-game inventory transactions
      crmInv: false, // CRM inventory transactions, should always be false for now
    },
    purge: { // Determines whether the game should purge transaction histories
      ss: false,
      rm: false,
      inv: false,
      crmInv: false, // should always be false for now
    },
  },
  eventPostcard: {
    enabled: false,
    range: {
      start: 1612915200000, // Feb 10, 2021 00:00:00 UTC
      end: 1613520000000, // Feb 17, 2021 00:00:00 UTC
    },
    levelButton: false,
  },
  dailyReward: { // daily reward features
    allowTripleReward: true, // 3x reward allowed when doubling is enabled
  },
  fortuneCookie: {
    enabled: true,
  },

  // Add real money wheels to game
  realMoneyPrizeWheel: true,
  realMoneyHelperWheel: true,
  realMoneyTargetedOfferWheel: true,

  unlockLevels: {
    coinDouble: 40,
  },
  weeklyTournament: { // weekly tournament settings
    enabled: true,
  },
  dailyChallenge: { // daily challenge settings
    enabled: true,
  },
  brag2: { enabled: false }, // brag 2.0 flow
  gateAlgorithm: 'conservative', // Algorithm for gate unlocking
  villains: true, // Setting this to false disables super hard levels, window villain speech bubbles, tutorials and corruption
  delayedBoardAppereance: true, // Set this to enable delayed board appereance for hard levels.
  multiplePreLevelBoosters: true, // Set this to allow for multiple pre level boosters on hard and super hard levels.
  allowLoyaltySupport: true,
  milestoneTracking: true,
  tokenEvent: {
    enabled: false,
  },
  additionalInterstitialRules: {
    initial: true, // Toggles addition interstitial display rules. This is the initial implementaton. Includes EveryN, Out of Moves, Win 2 in a row, Give up
    tournamentWin: {
      enabled: true,
    },
    giftAds: {
      enabled: true,
    },
  },
  weekendShopDeal: {
    enabled: true,
  },
  preventMysteryGift: false,
  annuityPacks: {
    enabled: true,
  },
};
